import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "source", "feedback" ]

  async copy() {
    const text = this.hasSourceTarget
      ? (this.sourceTarget.value || this.sourceTarget.textContent)
      : ""
    if (!text) return

    await navigator.clipboard.writeText(text)
    if (!this.hasFeedbackTarget) return

    this.feedbackTarget.hidden = false
    window.setTimeout(() => { this.feedbackTarget.hidden = true }, 2000)
  }
}
